"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/time-picker/style/css");

var _timePicker = _interopRequireDefault(require("antd/es/time-picker"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _ = _interopRequireWildcard(require("lodash"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _reactRedux = require("react-redux");

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./appointmentForm.scss");

var _AntdIcon = _interopRequireDefault(require("../antdIcon/AntdIcon"));

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const {
  Option
} = _select.default;

function filter(inputValue, path) {
  return path.some(option => option.label ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1 : false);
}

function range(start, end) {
  const result = [];

  for (let i = start; i <= end; i++) {
    result.push(i);
  }

  return result;
}

function disabledDate(current) {
  return !!(current && current < (0, _moment.default)().startOf('day'));
}

const labelColStyle = {
  padding: 0,
  maxWidth: '40px'
};

class AvailabilityForm extends _react.Component {
  constructor() {
    super(...arguments);

    this.disabledEndHours = () => {
      const {
        formRef
      } = this.props;
      const form = formRef.current;
      const start = (0, _moment.default)(form === null || form === void 0 ? void 0 : form.getFieldValue('startTime'));
      return range(0, start.hour() - 1);
    };

    this.disabledEndMinutes = () => {
      const {
        formRef
      } = this.props;
      const form = formRef.current;
      const start = (0, _moment.default)(form === null || form === void 0 ? void 0 : form.getFieldValue('startTime'));
      const end = (0, _moment.default)(form === null || form === void 0 ? void 0 : form.getFieldValue('endTime'));
      return (end === null || end === void 0 ? void 0 : end.isSame(start, 'hour')) ? range(0, start.minute()) : [];
    };

    this.onStartTimeBlur = value => {
      const form = this.props.formRef.current;

      if (form) {
        const start = (0, _moment.default)(form.getFieldValue('startTime'));
        const end = (0, _moment.default)(form.getFieldValue('endTime'));

        if (value.isSameOrAfter(end)) {
          // If new startTime is after the previous endTime,
          // we shift the endTime to be the same duration after
          // the new startTime.
          const diff = end.diff(start, 'minutes');
          const newEnd = value.clone();
          newEnd.add(diff, 'minutes');
          form.setFieldsValue({
            startTime: value,
            endTime: newEnd
          });
        } else {
          form.setFieldsValue({
            startTime: value
          });
        }

        this.props.onChange();
      }
    };

    this.onEndTimeBlur = value => {
      const form = this.props.formRef.current;

      if (form) {
        form.setFieldsValue({
          endTime: value
        });
        this.props.onChange();
      }
    };

    this.validateTimeRange = (rule, value) => {
      const {
        formRef
      } = this.props;
      const form = formRef.current;

      if (form) {
        const start = form.getFieldValue('startTime');
        const end = form.getFieldValue('endTime');

        if (!_moment.default.isMoment(start) || !_moment.default.isMoment(end)) {
          return Promise.reject();
        }

        return Promise.resolve();
      }
    };
  }

  render() {
    const {
      formRef,
      availability,
      admin,
      disabled
    } = this.props;
    const {
      id,
      userId,
      startDate,
      endDate
    } = availability;
    return /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: formRef,
      key: id,
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "userId",
      key: userId,
      rules: [{
        required: true,
        message: 'Admin is required.'
      }],
      initialValue: userId,
      label: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        classes: "form-item-icon",
        size: "lg",
        fontAwesomeIcon: _proRegularSvgIcons.faUser
      }),
      labelCol: {
        style: labelColStyle
      }
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      value: userId,
      disabled: disabled,
      style: {
        width: 'auto',
        minWidth: '200px'
      },
      onChange: () => this.props.onChange()
    }, _.map(admin, admin => /*#__PURE__*/_react.default.createElement(Option, {
      key: admin.id,
      value: admin.id
    }, ' ', admin.username, ' ')))), /*#__PURE__*/_react.default.createElement(Item, {
      className: "parent-form-item",
      style: {
        marginBottom: 0
      }
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "startDate",
      key: `${id}-startDate`,
      initialValue: (0, _moment.default)(startDate),
      rules: [{
        required: true,
        message: 'Start date is required.'
      }],
      style: {
        display: 'inline-block',
        width: 'calc(40% - 8px)'
      }
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      disabled: disabled,
      disabledDate: disabledDate,
      bordered: false,
      format: "YYYY-MM-DD",
      onChange: () => this.props.onChange()
    })), /*#__PURE__*/_react.default.createElement(Item, {
      name: "timeRange",
      key: `${id}-timeRange`,
      rules: [{
        required: true,
        message: 'Start and end times are required.',
        validator: this.validateTimeRange
      }],
      style: {
        display: 'inline-block',
        width: 'calc(60% - 8px)'
      }
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "startTime",
      key: `${id}-startTime`,
      initialValue: (0, _moment.default)(startDate),
      style: {
        marginBottom: 0,
        display: 'inline-block',
        width: 'calc(50% - 4px)'
      }
    }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
      showNow: false,
      bordered: false,
      onSelect: this.onStartTimeBlur,
      format: "hh:mm A",
      minuteStep: 5,
      disabled: disabled
    })), /*#__PURE__*/_react.default.createElement(Item, {
      name: "endTime",
      key: `${id}-endTime`,
      initialValue: (0, _moment.default)(endDate),
      style: {
        marginBottom: 0,
        display: 'inline-block',
        width: 'calc(50% - 4px)'
      }
    }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
      showNow: false,
      disabledHours: this.disabledEndHours,
      disabledMinutes: this.disabledEndMinutes,
      bordered: false,
      onSelect: this.onEndTimeBlur,
      format: "hh:mm A",
      minuteStep: 5,
      disabled: disabled
    })))));
  }

}

const mapStateToProps = state => {
  return {
    admin: selectors.getAdmin(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AvailabilityForm);

exports.default = _default;